import { render, staticRenderFns } from "./T-F-Under-Grad-2023-CN.vue?vue&type=template&id=d0f3aa30&scoped=true"
import script from "./T-F-Under-Grad-2023-CN.vue?vue&type=script&lang=js"
export * from "./T-F-Under-Grad-2023-CN.vue?vue&type=script&lang=js"
import style0 from "./T-F-Under-Grad-2023-CN.vue?vue&type=style&index=0&id=d0f3aa30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f3aa30",
  null
  
)

export default component.exports